// import React from 'react'
// import "../style/Dashboard.css";
// import Journal from "../assets/images/Dashboard/7.jpg"
// import Policy from "../assets/images/Dashboard/6.png";
// import IEW from "../assets/images/Dashboard/5.jpg"

// const Dashboard = ({ onIEWClick }) => {

//   return (
//     <div className='container'>
//       <div className='card' onClick={onIEWClick}>
//         <img src={IEW} alt="India Energy Week" />
//         <h3>India Energy Week</h3>
//         <div className='card-content'>
//           <ul>
//             <li><i className="fa-xs fa-solid fa-caret-right"></i>Energy Innovation</li>
//             <li><i className="fa-xs fa-solid fa-caret-right"></i>Sustainability Focus</li>
//             <li><i className="fa-xs fa-solid fa-caret-right"></i>Global Collaboration</li>
//           </ul>
//         </div>
//         <div className="card-link">
//           <a href="">Explore More Contents</a>
//         </div>
//       </div>
//       <div className='card' onClick={() => window.open("https://www.fipi.org.in/fipi-journal.php", "_blank")}>
//         <img src={Journal} alt="" />
//         <h3>Journal </h3>
//         <div className='card-content'>
//           <ul>
//             <li><i className="fa-xs fa-solid fa-caret-right"></i>Scholarly Articles</li>
//             <li><i className="fa-xs fa-solid fa-caret-right"></i>Peer Reviewed</li>
//             <li><i className="fa-xs fa-solid fa-caret-right"></i>Industry Insights</li>
//           </ul>
//         </div>

//         <div className="card-link">
//           <a href="">Explore More Contents</a>
//         </div>
//       </div>
//       <div className='card' onClick={() => window.open("https://www.fipi.org.in/policy-economic.php", "_blank")}>
//         <img src={Policy} alt="" />
//         <h3>Policy Report</h3>
//         <div className='card-content'>
//           <ul>
//             <li><i className="fa-xs fa-solid fa-caret-right"></i>Regulatory Updates</li>
//             <li><i className="fa-xs fa-solid fa-caret-right"></i>Strategic Frameworks</li>
//             <li><i className="fa-xs fa-solid fa-caret-right"></i>Government Insights</li>
//           </ul>
//         </div>
//         <div className="card-link">
//           <a href="">Explore More Contents</a>
//         </div>
//       </div>
//     </div>
//   )
// }

// export default Dashboard





// #Dashboard.jsx 

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

import "../style/Dashboard.css";
import IEWThumb from "../assets/images/i/IEW thumbnail.jpeg";
import ImportantLinksThumb from "../assets/images/i/Industry insights.jpg";
import NotificationThumb from "../assets/images/i/Regulatory Updates.jpg";
import PublicationThumb from "../assets/images/i/FIPI Publications.jpeg";
import RecommendationThumb from "../assets/images/i/Recommendation.jpg";
import ReportsThumb from "../assets/images/i/Reports.jpg";
import LoginModal from "./LoginModal";



const Dashboard = ({ onLoginSuccess }) => {
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [loginType, setLoginType] = useState("user");
  const navigate = useNavigate();
  const { login,authUser } = useAuth();



  // Handle IEW card click - show user login
  // const handleIEWClick = () => {
  //   setLoginType("user");
  //   setShowLoginModal(true);
  // };

  const handleIEWClick = () => {
  // already logged in
  if (authUser) {
    const role =
      authUser?.role ||
      authUser?.user_role ||
      authUser?.is_admin ||
      authUser?.group;

    const isAdmin =
      role === "admin" ||
      role === "ADMIN" ||
      role === 1 ||
      role === true;

    navigate(isAdmin ? "/Admin" : "/library");
    return;
  }

  // not logged in
  setLoginType("user");
  setShowLoginModal(true);
};

  // Handle admin button click
  const handleAdminClick = (e) => {
    e.stopPropagation();
    setLoginType("admin");
    setShowLoginModal(true);
  };

  const handleFipiPublicationClick = () => {
    navigate("/fipi-publication");
  };
  const handleRecommendationClick = () => {
    navigate("/fipi-recommendation");
  };
  const handleReportClick = () => {
    navigate("/Reports");
  };
  const handleImportantLinksClick = () => {
    navigate("/important-links");
  };
  const handleAdminImportantLinksClick = () => {
    // navigate("/admin-important-links");s
    navigate("/Notification");

  };

  // const handleLoginSuccess = (user) => {
  //   login(user);
  //   setShowLoginModal(false);

  //   if (user.role === "admin") {
  //     navigate("/Admin");
  //   } else {
  //     navigate("/library");
  //   }
  // };

  const handleLoginSuccess = (userData, access, refresh) => {
    // save in auth context with tokens (sessionStorage only)
    login(userData, access, refresh);

    setShowLoginModal(false);

    // detect admin safely
    const role =
      userData?.role ||
      userData?.user_role ||
      userData?.is_admin ||
      userData?.group;

    const isAdmin =
      role === "admin" ||
      role === "ADMIN" ||
      role === 1 ||
      role === true;

    // role based navigation
    navigate(isAdmin ? "/Admin" : "/library", { replace: true });
  };


  return (
    <div className="container"
      style={{
        display: "grid",
        justifyItems: "center",
        gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
        gap: "24px",
        width: "100%",
      }}>
      {/* India Energy Week Card */}
      <div
        className="card"
        onClick={handleIEWClick}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") handleIEWClick();
        }}
        style={{ position: "relative" }}
      >
        <img src={IEWThumb} alt="India Energy Week" />
        <h3>India Energy Week</h3>

        {/* Admin Button - Top Right Corner */}
        <div style={{ position: "absolute", top: 8, right: 12, zIndex: 10 }}>

        </div>

        <div className="card-content">
          <ul>
            <li>
              <i className="fa-xs fa-solid fa-caret-right" /> Energy Innovation
            </li>
            <li>
              <i className="fa-xs fa-solid fa-caret-right" /> Sustainability Focus
            </li>
            <li>
              <i className="fa-xs fa-solid fa-caret-right" /> Global Collaboration
            </li>
          </ul>
        </div>
        <div className="card-link">
          <a href="#!" onClick={(e) => e.preventDefault()}>
            Explore More Contents
          </a>
        </div>
      </div>

      {/* Journal Card */}
      <div
        className="card"
        onClick={handleImportantLinksClick}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") handleImportantLinksClick();
        }}
      >
        <img src={ImportantLinksThumb} alt="Important Links" />
        <h3>Important Links</h3>
        <div className="card-content">
          <ul>
            <li>
              <i className="fa-xs fa-solid fa-caret-right" /> Government & Regulatory
            </li>
            <li>
              <i className="fa-xs fa-solid fa-caret-right" /> Petroleum Sector CPSEs
            </li>

          </ul>
        </div>
        <div className="card-link">
          <a href="#!" onClick={(e) => e.preventDefault()}>
            Explore More Contents
          </a>
        </div>
      </div>

      {/* Policy Report Card */}
      <div
        className="card"
        onClick={handleAdminImportantLinksClick}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") handleAdminImportantLinksClick();
        }}
      >
        <img src={NotificationThumb} alt="Notification" />
        <h3>Gazette Notifications</h3>
        <div className="card-content">
          <ul>
            <li>
              <i className="fa-xs fa-solid fa-caret-right" /> Regulatory Updates
            </li>
            <li>
              <i className="fa-xs fa-solid fa-caret-right" /> Strategic Frameworks
            </li>
            <li>
              <i className="fa-xs fa-solid fa-caret-right" /> Government Insights
            </li>
          </ul>
        </div>
        <div className="card-link">
          <a href="#!" onClick={(e) => e.preventDefault()}>
            Explore More Contents
          </a>
        </div>
      </div>

      {/* Card 4 */}
      {/* <div className="card">
  <img src={IEW} alt="Events" />
  <h3>Fipi Publication</h3>
  <div className="card-content">
    <ul>
      <li><i className="fa-xs fa-solid fa-caret-right" /> Policy Econimic Report</li>
      <li><i className="fa-xs fa-solid fa-caret-right" /> Jornal</li>
      <li><i className="fa-xs fa-solid fa-caret-right" /> Annual Reports</li>
    </ul>
  </div>
  <div className="card-link">
    <a href="#!" onClick={(e) => e.preventDefault()}>Explore More Contents</a>
  </div>
</div> */}

      {/* Card 4 */}
      <div
        className="card"
        onClick={handleFipiPublicationClick}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") handleFipiPublicationClick();
        }}
      >
        <img src={PublicationThumb} alt="FIPI Publication" />
        <h3>FIPI Publications</h3>
        <div className="card-content">
          <ul>
            <li><i className="fa-xs fa-solid fa-caret-right" /> Monthly Policy Economic Reports</li>
            <li><i className="fa-xs fa-solid fa-caret-right" /> Quarterly Journals</li>
            <li><i className="fa-xs fa-solid fa-caret-right" /> Annual Reports</li>
          </ul>
        </div>
        <div className="card-link">
          <a href="#!" onClick={(e) => e.preventDefault()}>
            Explore More Contents
          </a>
        </div>
      </div>


      {/* Card 5 */}
      <div
        className="card"
        onClick={handleRecommendationClick}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") handleRecommendationClick();
        }}>
        <img src={RecommendationThumb} alt="Recommendation" />
        <h3>Recommendations</h3>
        <div className="card-content">
          <ul>
            <li><i className="fa-xs fa-solid fa-caret-right" /> Finance and Taxation</li>
            <li><i className="fa-xs fa-solid fa-caret-right" /> Upstream</li>
            <li><i className="fa-xs fa-solid fa-caret-right" /> Downstream</li>
            <li><i className="fa-xs fa-solid fa-caret-right" /> Natural Gas</li>
          </ul>
        </div>
        <div className="card-link">
          <a href="#!" onClick={(e) => e.preventDefault()}>Explore More Contents</a>
        </div>
      </div>

      {/* Card 6 */}
        <div
        className="card"
        onClick={handleReportClick}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") handleReportClick();
        }}>
        <img src={ReportsThumb} alt="Reports" />
        <h3>Reports</h3>
        <div className="card-content">
          <ul>
            <li><i className="fa-xs fa-solid fa-caret-right" />Upstream</li>
            <li><i className="fa-xs fa-solid fa-caret-right" />Downstream</li>
            <li><i className="fa-xs fa-solid fa-caret-right" />Natural Gas</li>
            <li><i className="fa-xs fa-solid fa-caret-right" />Economic Policy</li>
          </ul>
        </div>
        <div className="card-link">
          <a href="#!" onClick={(e) => e.preventDefault()}>Explore More Contents</a>
        </div>
      </div>


      {/* Login Modal */}
      {showLoginModal && (
        <LoginModal
          type={loginType}
          onClose={() => setShowLoginModal(false)}
          onLoginSuccess={handleLoginSuccess}
        />
      )}
    </div>
  );
};

export default Dashboard;